import { render, staticRenderFns } from "./LoginStudent.vue?vue&type=template&id=d9c5f8c2&"
import script from "./LoginStudent.vue?vue&type=script&lang=js&"
export * from "./LoginStudent.vue?vue&type=script&lang=js&"
import style0 from "./LoginStudent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LoginStudent.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./LoginStudent.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports